import { PageOptions } from './page-options';

export enum CommandTypes {
  'ad' = 'ad',
  'tag' = 'tag',
  'config' = 'config',
  'unknown' = 'unknwown',
}

export interface Options {
  options: Partial<PageOptions>;
  extras: {
    iid: string;
    aud: Record<string, unknown>;
  };
}

export type CommandArray = [
  CommandTypes,
  HTMLOrSVGScriptElement | string,
  string,
  PageOptions,
  Options,
];

export type Command = CommandArray | Options;

export interface TagCommand {
  target: HTMLOrSVGScriptElement | string;
  tagId: string;
  page: PageOptions;
  config: Partial<PageOptions>;
}
